import { priceField } from '../../components/table/CommonFields';
import { format } from 'date-fns';

export const fields = {
  config: { columns: 1 },
  fields: [
    {
      name: 'paymentDate',
      label: 'Data płatności',
      type: 'date',
      column: 1,
      mandatory: true,
      minDateNow: false
    },
    {
      name: 'transactionType',
      label: 'Typ transakcji',
      type: 'enum',
      column: 1,
      mandatory: true,
      defaultValue: "PAYMENT",
      enumType: "enums/transactionType",
    },
    {
      name: 'paymentType',
      label: 'Rodzaj płatności',
      type: 'dictionary',
      dictionary: 'paymentType',
      column: 1,
      mandatory: true,
    },
    priceField(1, 'amount', 'Kwota'),
    {
      name: 'paymentComment',
      label: 'Komentarz',
      type: 'textarea',
      column: 1,
    },
    {
      name: 'confirmed',
      label: 'Płatność zakończona',
      type: 'boolean',
      column: 1,
      defaultValue: true,
      mandatory: true,
    },
  ],
};

export default fields;
